define("shared/utils/media-adjustments/attribute-preview-resolution", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.attributePreviewResolution = attributePreviewResolution;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * Attributes how a preview reached its resolved status, for latency observability.
   *
   * A persisted PMI's preview resolves two ways: the Nexus/Faye push writes the resolved status
   * straight into the store, or one of the modal's own GET/POST polls returns it. We tell them apart
   * by comparing the status the *most recent poll* returned against the status now in the store — if
   * the poll itself returned the resolved status it resolved it; otherwise the store reached that
   * status out-of-band, i.e. via the push.
   *
   * Caveat for analysis: in a race where a poll GET returns the resolved status at the same moment the
   * push lands, this attributes `poll`. So the `push` share is a *lower bound* — real push
   * effectiveness is at least what the data shows.
   *
   * @param lastPollStatus The preview status the most recent GET/POST poll returned, if any
   * @param resolvedStatus The resolved preview status now reflected in the store
   * @returns `'poll'` when the poll observed the resolution, otherwise `'push'`
   */
  function attributePreviewResolution(lastPollStatus, resolvedStatus) {
    return lastPollStatus === resolvedStatus ? 'poll' : 'push';
  }
});